import dayjs from 'dayjs';

// Marca de gestión local para Gestión de Errores. Permite que al volver al detalle
// el ítem se vea como "GESTIONADO" mientras el backend procesa.
const STORAGE_KEY_GESTION_MARCACION = 'gestion_errores:gestion_marcacion:ultimo';

// Normaliza fechas para evitar mandar "Invalid Date" al backend.
// Acepta:
// - YYYY-MM-DD
// - DD/MM/YYYY
// - ISO / SQL: YYYY-MM-DDTHH:mm:ss / YYYY-MM-DD HH:mm:ss
// - HTTP-date: Tue, 13 Jan 2026 00:00:00 GMT
export const toISODate = (value: any): string => {
  const raw = String(value ?? '').trim();
  if (!raw) return '';
  const m = raw.match(/^(\d{4}-\d{2}-\d{2})/);
  if (m) return m[1];
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) {
    const [dd, mm, yyyy] = raw.split('/');
    return `${yyyy}-${mm}-${dd}`;
  }
  const d = dayjs(raw);
  return d.isValid() ? d.format('YYYY-MM-DD') : '';
};

interface MarcarGestionPayload {
  tipo_error: string;
  nombrePServicio: string;
  nroLegajo: number | string;
  fecha: string;
}

// Suma dos horas en formato 'H:MM' o 'HH:MM' (o 'H:MM:SS') y devuelve 'HH:MM'.
// Útil para acumular tipos de hora distintos que conceptualmente son la misma categoría
// (ej. HNOC + HNOCM, ambos "nocturna").
export const sumarHorasHHMM = (a: any, b: any): string => {
  const parsear = (raw: any): number => {
    if (raw === null || raw === undefined) return 0;
    const partes = String(raw).split(':');
    if (partes.length < 2) return 0;
    const h = parseInt(partes[0], 10);
    const m = parseInt(partes[1], 10);
    if (!Number.isFinite(h) || !Number.isFinite(m)) return 0;
    return h * 60 + m;
  };
  const total = parsear(a) + parsear(b);
  const hh = Math.floor(total / 60);
  const mm = total % 60;
  return `${hh.toString().padStart(2, '0')}:${mm.toString().padStart(2, '0')}`;
};

export const marcarGestionEnGestionErrores = (payload: MarcarGestionPayload) => {
  try {
    const legajoNum = Number(payload.nroLegajo);
    sessionStorage.setItem(
      STORAGE_KEY_GESTION_MARCACION,
      JSON.stringify({
        tipo_error: payload.tipo_error,
        ps_nombre: String(payload.nombrePServicio || '').trim(),
        operario_legajo: Number.isFinite(legajoNum) ? legajoNum : null,
        fecha: payload.fecha,
      })
    );
  } catch {
    // Si el storage no está disponible, no bloqueamos la UX.
  }
};
